import {
  boolean,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
  uuid,
  index,
  uniqueIndex,
} from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

export const UGC_SOURCE_TYPES = ["review", "social_mention", "manual"] as const;
export type UgcSourceType = (typeof UGC_SOURCE_TYPES)[number];

export const UGC_MEDIA_TYPES = ["image", "video", "text"] as const;
export type UgcMediaType = (typeof UGC_MEDIA_TYPES)[number];

export const UGC_APPROVAL_STATUSES = ["pending", "approved", "rejected"] as const;
export type UgcApprovalStatus = (typeof UGC_APPROVAL_STATUSES)[number];

export const UGC_RIGHTS_STATUSES = ["not_requested", "requested", "granted", "denied"] as const;
export type UgcRightsStatus = (typeof UGC_RIGHTS_STATUSES)[number];

export const ugcItems = pgTable("ugc_items", {
  id: uuid("id").primaryKey().defaultRandom(),
  tenantId: uuid("tenant_id").notNull(),
  sourceType: text("source_type").notNull(),
  sourceId: uuid("source_id"),
  platform: text("platform"),
  externalContentId: text("external_content_id"),
  authorName: text("author_name"),
  authorHandle: text("author_handle"),
  contentText: text("content_text"),
  sourceUrl: text("source_url"),
  publishedAt: timestamp("published_at", { withTimezone: true }),
  primaryMediaUploadId: uuid("primary_media_upload_id"),
  mediaUrl: text("media_url"),
  mediaType: text("media_type").notNull().default("text"),
  hashtags: jsonb("hashtags").$type<string[]>().notNull().default([]),
  approvalStatus: text("approval_status").notNull().default("pending"),
  reviewedAt: timestamp("reviewed_at", { withTimezone: true }),
  reviewedBy: uuid("reviewed_by"),
  rightsStatus: text("rights_status").notNull().default("not_requested"),
  rightsRequestedAt: timestamp("rights_requested_at", { withTimezone: true }),
  rightsGrantedAt: timestamp("rights_granted_at", { withTimezone: true }),
  consentRecordId: uuid("consent_record_id"),
  approvedForEmbedding: boolean("approved_for_embedding").notNull().default(false),
  embeddingApprovedAt: timestamp("embedding_approved_at", { withTimezone: true }),
  embeddingApprovedBy: uuid("embedding_approved_by"),
  engagements: integer("engagements").notNull().default(0),
  reach: integer("reach").notNull().default(0),
  metadata: jsonb("metadata").$type<Record<string, unknown>>().notNull().default({}),
  createdAt: timestamp("created_at", { withTimezone: true }).defaultNow().notNull(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).defaultNow().notNull(),
  deletedAt: timestamp("deleted_at", { withTimezone: true }),
}, (table) => [
  uniqueIndex("uq_ugc_items_source")
    .on(table.tenantId, table.sourceType, table.sourceId)
    .where(sql`${table.sourceId} IS NOT NULL`),
  index("idx_ugc_items_approval").on(table.tenantId, table.approvalStatus, table.createdAt),
  index("idx_ugc_items_rights").on(table.tenantId, table.rightsStatus, table.createdAt),
  index("idx_ugc_items_embedding").on(table.tenantId, table.approvedForEmbedding, table.createdAt),
  index("idx_ugc_items_media").on(table.tenantId, table.primaryMediaUploadId),
]);
